(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-dd-root]');
  Array.prototype.forEach.call(roots, init);
  function init(root) {
    var T = function (k) { return root.getAttribute('data-' + k) || ''; };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var q = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
    var cartUrl = T('cart-url') || '/cart';
    var rootUrl = T('root-url') || '/';

    if ('IntersectionObserver' in window && !reduce) {
      root.classList.add('dd-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      q('.dd-reveal').forEach(function (el) { io.observe(el); });
      setTimeout(function () { q('.dd-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
    }

    q('[data-dd="flip"]').forEach(function (flip) {
      var stage = flip.querySelector('.dd-flip__stage');
      var btns = q('.dd-seg__btn', flip);
      if (!stage) return;
      var set = function (side) {
        stage.classList.toggle('is-back', side === 'back');
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-side') === side ? 'true' : 'false'); });
      };
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-side')); }); });
      stage.addEventListener('click', function () { set(stage.classList.contains('is-back') ? 'front' : 'back'); });
    });

    /* ---- Buy boxes (server-rendered) ---- */
    var boxes = q('[data-dd="buy"]');
    var chosen = {};
    function setMsg(box, t, err) { var m = box.querySelector('[data-dd="buy-msg"]'); if (!m) return; m.textContent = t || ''; m.classList.toggle('is-error', !!err); }
    function lowStock(box, qty) {
      var st = box.querySelector('[data-dd="stock"]'); if (!st) return;
      var n = parseInt(qty, 10);
      if (n > 0 && n <= 8 && T('low-stock')) { st.textContent = T('low-stock').replace('{n}', n); st.hidden = false; }
      else { st.textContent = ''; st.hidden = true; }
    }
    function selected(box) {
      var single = box.querySelector('.dd-buy__single');
      if (single) return { id: single.getAttribute('data-id'), qty: single.getAttribute('data-qty') };
      var id = chosen[box.getAttribute('data-handle')];
      if (!id) return null;
      var b = box.querySelector('.dd-buy__size[data-id="' + id + '"]');
      return { id: id, qty: b ? b.getAttribute('data-qty') : '' };
    }
    function syncBox(box) {
      var id = chosen[box.getAttribute('data-handle')];
      q('.dd-buy__size', box).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-id') === id ? 'true' : 'false'); });
      var sel = selected(box);
      if (sel) {
        var now = box.querySelector('[data-dd="buy-now"]');
        if (now) now.href = cartUrl + '/' + sel.id + ':1';
        lowStock(box, sel.qty);
        setMsg(box, '');
      }
    }
    function needSize(box) {
      setMsg(box, T('live-pick'), true);
      var s = box.querySelector('.dd-buy__sizes');
      if (s) { s.classList.remove('is-nudge'); void s.offsetWidth; s.classList.add('is-nudge'); }
    }
    function busy(on) {
      q('[data-dd="add"], [data-dd="sticky-cta"]').forEach(function (b) { b.classList.toggle('is-busy', on); if (on) b.setAttribute('data-was', b.disabled ? '1' : ''); b.disabled = on || b.getAttribute('data-was') === '1'; });
    }
    function addToCart(box) {
      var sel = selected(box);
      if (!sel) { needSize(box); return; }
      busy(true); setMsg(box, '');
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(sel.id, 10), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          try { if (window.dataLayer) window.dataLayer.push({ event: 'landing_add_to_cart', handle: box.getAttribute('data-handle'), variant: sel.id }); } catch (_) {}
          window.location.href = cartUrl;
        })
        .catch(function () { busy(false); setMsg(box, T('live-error'), true); });
    }
    boxes.forEach(function (box) {
      var h = box.getAttribute('data-handle');
      q('.dd-buy__size', box).forEach(function (b) {
        b.addEventListener('click', function () {
          chosen[h] = b.getAttribute('data-id');
          boxes.forEach(function (o) { if (o.getAttribute('data-handle') === h) syncBox(o); });
        });
      });
      var single = box.querySelector('.dd-buy__single');
      if (single) lowStock(box, single.getAttribute('data-qty'));
      var add = box.querySelector('[data-dd="add"]');
      if (add) add.addEventListener('click', function () { addToCart(box); });
      var now = box.querySelector('[data-dd="buy-now"]');
      if (now) now.addEventListener('click', function (e) {
        if (!selected(box)) { e.preventDefault(); needSize(box); return; }
        try { if (window.dataLayer) window.dataLayer.push({ event: 'landing_buy_now', handle: h }); } catch (_) {}
      });
      /* preselect the only size in stock */
      var avail = q('.dd-buy__size:not([disabled])', box);
      if (avail.length === 1 && !chosen[h]) { chosen[h] = avail[0].getAttribute('data-id'); syncBox(box); }
    });

    /* ---- Sticky bar ---- */
    var sticky = root.querySelector('[data-dd="sticky"]');
    var main = root.querySelector('.dd-hero [data-dd="buy"]');
    var finalSec = root.querySelector('.dd-final');
    if (sticky && 'IntersectionObserver' in window) {
      var mainSeen = false, finalSeen = false;
      var update = function () {
        var show = !mainSeen && !finalSeen;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      var mainEl = main || root.querySelector('.dd-hero');
      if (mainEl) new IntersectionObserver(function (en) { mainSeen = en[0].isIntersecting; update(); }, { threshold: 0.35 }).observe(mainEl);
      if (finalSec) new IntersectionObserver(function (en) { finalSeen = en[0].isIntersecting; update(); }, { threshold: 0.25 }).observe(finalSec);
      update();
    }
    var stickyCta = root.querySelector('[data-dd="sticky-cta"]');
    if (stickyCta && main) {
      stickyCta.addEventListener('click', function () {
        if (selected(main)) { addToCart(main); return; }
        main.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { needSize(main); }, reduce ? 0 : 450);
      });
    }

    /* ---- Shelf carousel arrows ---- */
    q('[data-dd="shelf"]').forEach(function (sh) {
      var track = sh.querySelector('[data-dd="track"]');
      var prev = sh.querySelector('[data-dd="prev"]');
      var next = sh.querySelector('[data-dd="next"]');
      if (!track || !prev || !next) return;
      var step = function () { var it = track.querySelector('.dd-shelf__item'); return it ? it.getBoundingClientRect().width + 16 : 300; };
      var sync = function () {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrapper = document.getElementById("ascova-megamenu-{{ section.id }}");
    if (!wrapper) return;
    var trigger = wrapper.querySelector(".ascova-megamenu__trigger");
    var dropdown = wrapper.querySelector(".ascova-megamenu__dropdown");
    var timer = null;

    function open() {
      clearTimeout(timer);
      trigger.setAttribute("aria-expanded", "true");
      dropdown.classList.add("is-open");
    }

    function close() {
      trigger.setAttribute("aria-expanded", "false");
      dropdown.classList.remove("is-open");
    }

    function delayClose() {
      timer = setTimeout(close, 160);
    }

    wrapper.addEventListener("mouseenter", open);
    wrapper.addEventListener("mouseleave", delayClose);
    dropdown.addEventListener("mouseenter", function () { clearTimeout(timer); });
    dropdown.addEventListener("mouseleave", delayClose);

    trigger.addEventListener("click", function () {
      trigger.getAttribute("aria-expanded") === "true" ? close() : open();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });

    document.addEventListener("click", function (e) {
      if (!wrapper.contains(e.target)) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restock-overshirt"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-ov-root]');
  Array.prototype.forEach.call(roots, init);
  function init(root) {
    var T = function (k) { return root.getAttribute('data-' + k) || ''; };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var q = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
    var cartUrl = T('cart-url') || '/cart';
    var rootUrl = T('root-url') || '/';

    if ('IntersectionObserver' in window && !reduce) {
      root.classList.add('ov-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      q('.ov-reveal').forEach(function (el) { io.observe(el); });
      setTimeout(function () { q('.ov-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
    }

    q('[data-ov="flip"]').forEach(function (flip) {
      var stage = flip.querySelector('.ov-flip__stage');
      var btns = q('.ov-seg__btn', flip);
      if (!stage) return;
      var set = function (side) {
        stage.classList.toggle('is-back', side === 'back');
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-side') === side ? 'true' : 'false'); });
      };
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-side')); }); });
      stage.addEventListener('click', function () { set(stage.classList.contains('is-back') ? 'front' : 'back'); });
    });

    /* ---- Buy boxes (server-rendered) ---- */
    var boxes = q('[data-ov="buy"]');
    var chosen = {};
    function setMsg(box, t, err) { var m = box.querySelector('[data-ov="buy-msg"]'); if (!m) return; m.textContent = t || ''; m.classList.toggle('is-error', !!err); }
    function lowStock(box, qty) {
      var st = box.querySelector('[data-ov="stock"]'); if (!st) return;
      var n = parseInt(qty, 10);
      if (n > 0 && n <= 8 && T('low-stock')) { st.textContent = T('low-stock').replace('{n}', n); st.hidden = false; }
      else { st.textContent = ''; st.hidden = true; }
    }
    function selected(box) {
      var single = box.querySelector('.ov-buy__single');
      if (single) return { id: single.getAttribute('data-id'), qty: single.getAttribute('data-qty') };
      var id = chosen[box.getAttribute('data-handle')];
      if (!id) return null;
      var b = box.querySelector('.ov-buy__size[data-id="' + id + '"]');
      return { id: id, qty: b ? b.getAttribute('data-qty') : '' };
    }
    function syncBox(box) {
      var id = chosen[box.getAttribute('data-handle')];
      q('.ov-buy__size', box).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-id') === id ? 'true' : 'false'); });
      var sel = selected(box);
      if (sel) {
        var now = box.querySelector('[data-ov="buy-now"]');
        if (now) now.href = cartUrl + '/' + sel.id + ':1';
        lowStock(box, sel.qty);
        setMsg(box, '');
      }
    }
    function needSize(box) {
      setMsg(box, T('live-pick'), true);
      var s = box.querySelector('.ov-buy__sizes');
      if (s) { s.classList.remove('is-nudge'); void s.offsetWidth; s.classList.add('is-nudge'); }
    }
    function busy(on) {
      q('[data-ov="add"], [data-ov="sticky-cta"]').forEach(function (b) { b.classList.toggle('is-busy', on); if (on) b.setAttribute('data-was', b.disabled ? '1' : ''); b.disabled = on || b.getAttribute('data-was') === '1'; });
    }
    function addToCart(box) {
      var sel = selected(box);
      if (!sel) { needSize(box); return; }
      busy(true); setMsg(box, '');
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(sel.id, 10), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          try { if (window.dataLayer) window.dataLayer.push({ event: 'landing_add_to_cart', handle: box.getAttribute('data-handle'), variant: sel.id }); } catch (_) {}
          window.location.href = cartUrl;
        })
        .catch(function () { busy(false); setMsg(box, T('live-error'), true); });
    }
    boxes.forEach(function (box) {
      var h = box.getAttribute('data-handle');
      q('.ov-buy__size', box).forEach(function (b) {
        b.addEventListener('click', function () {
          chosen[h] = b.getAttribute('data-id');
          boxes.forEach(function (o) { if (o.getAttribute('data-handle') === h) syncBox(o); });
        });
      });
      var single = box.querySelector('.ov-buy__single');
      if (single) lowStock(box, single.getAttribute('data-qty'));
      var add = box.querySelector('[data-ov="add"]');
      if (add) add.addEventListener('click', function () { addToCart(box); });
      var now = box.querySelector('[data-ov="buy-now"]');
      if (now) now.addEventListener('click', function (e) {
        if (!selected(box)) { e.preventDefault(); needSize(box); return; }
        try { if (window.dataLayer) window.dataLayer.push({ event: 'landing_buy_now', handle: h }); } catch (_) {}
      });
      /* preselect the only size in stock */
      var avail = q('.ov-buy__size:not([disabled])', box);
      if (avail.length === 1 && !chosen[h]) { chosen[h] = avail[0].getAttribute('data-id'); syncBox(box); }
    });

    /* ---- Sticky bar ---- */
    var sticky = root.querySelector('[data-ov="sticky"]');
    var main = root.querySelector('.ov-hero [data-ov="buy"]');
    var finalSec = root.querySelector('.ov-final');
    if (sticky && 'IntersectionObserver' in window) {
      var mainSeen = false, finalSeen = false;
      var update = function () {
        var show = !mainSeen && !finalSeen;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      var mainEl = main || root.querySelector('.ov-hero');
      if (mainEl) new IntersectionObserver(function (en) { mainSeen = en[0].isIntersecting; update(); }, { threshold: 0.35 }).observe(mainEl);
      if (finalSec) new IntersectionObserver(function (en) { finalSeen = en[0].isIntersecting; update(); }, { threshold: 0.25 }).observe(finalSec);
      update();
    }
    var stickyCta = root.querySelector('[data-ov="sticky-cta"]');
    if (stickyCta && main) {
      stickyCta.addEventListener('click', function () {
        if (selected(main)) { addToCart(main); return; }
        main.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { needSize(main); }, reduce ? 0 : 450);
      });
    }

    /* ---- Shelf carousel arrows ---- */
    q('[data-ov="shelf"]').forEach(function (sh) {
      var track = sh.querySelector('[data-ov="track"]');
      var prev = sh.querySelector('[data-ov="prev"]');
      var next = sh.querySelector('[data-ov="next"]');
      if (!track || !prev || !next) return;
      var step = function () { var it = track.querySelector('.ov-shelf__item'); return it ? it.getBoundingClientRect().width + 16 : 300; };
      var sync = function () {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
